import {
  Grid,
  makeStyles,
  Typography,
  Box,
  CircularProgress
} from '@material-ui/core';
import React, { FC, useEffect, useState } from 'react';
import { SaveOrderAsyncViewState } from '../../../domain/models/SaveOrderViewState';
import { useOrdering } from '../../../stores/OrderingStore';

const useStyles = makeStyles(theme => ({
  container: {
    height: '100%',
    lineHeight: '26pt'
  },
  icon: {
    margin: theme.spacing(8)
  },
  typo: {
    whiteSpace: 'pre-wrap'
  }
}));

const Waiting: FC<{}> = () => {
  const classes = useStyles();
  const orderingStore = useOrdering();
  const { submitState } = orderingStore;
  const [note, setNote] = useState('');

  useEffect(() => {
    if (submitState === SaveOrderAsyncViewState.PAYING) {
      setNote(
        'Your order is being processed. Please do not close or reload this browser.'
      );
    } else if (submitState === SaveOrderAsyncViewState.WAITINGFAILED) {
      setNote(
        'It took longer than expected to process your order.\nPlease check your email to see if the order has been placed successfully.'
      );
    }
  }, [setNote, submitState]);

  return (
    <Grid
      container
      className={classes.container}
      direction="column"
      alignContent="center"
      alignItems="center"
      justify="center"
    >
      <CircularProgress className={classes.icon} />
      <Box>
        <Typography className={classes.typo} color="secondary" align="center">
          {note}
        </Typography>
      </Box>
    </Grid>
  );
};

export default Waiting;
